import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import { isBlank } from '@ember/utils';

export default class NewRoute extends Route {
  templateName = 'layout.edit';

  @service confirmChanges;
  @service store;

  crumb() {
    return {
      name: 'New',
      path: 'layouts.new',
    };
  }

  model(params) {
    let newLayout = this.store.createRecord('layout');
    let { starter_layout_id: starterLayoutId, name } = params;

    if (starterLayoutId) {
      let starterLayouts = this.controllerFor('layouts/starters').get('starterLayouts');
      let selectedLayoutStart = starterLayouts.findBy('id', parseInt(starterLayoutId));
      let body = isBlank(selectedLayoutStart.body) ? newLayout.get('body') : selectedLayoutStart.body;

      newLayout.setProperties({
        body,
        name,
        starterLayoutId,
      });
    }

    return newLayout;
  }

  setupController(controller, model, transition) {
    super.setupController(controller, model, transition);

    this.confirmChanges.register(controller, this);
  }

  deactivate() {
    super.deactivate(...arguments);
    this.rollbackModelFor();
    this.controller.set('model', null);
  }
}
